module.exports = __webpack_public_path__ + "img/parking-free.f657bd94.svg";